class FlipBook extends HTMLElement{
    constructor(){
        super();
        this.querySelector("button[id='increment_button']").addEventListener("click",this.incrementPg.bind(this));
        this.querySelector("button[id='decrement_button']").addEventListener("click",this.decrementPg.bind(this));

        this.guidecontainer=document.getElementById("g_container");
        this.img1=document.getElementById("page_renderer-1");
        this.img2=document.getElementById("page_renderer-2");
        this.pg2=document.getElementById("pg2");
        this.pdf_bp=this.querySelector("div[id='pdf_base_path']").getAttribute("data-value");
        this.max_pg=parseInt(this.querySelector("div[id='max_pg_value']").getAttribute("data-value"));
        this.pg_num_slice=1;
        this.pdf_filter="#toolbar=0&zoom=FitW&navpanes=0&scrollbar=0"
    }

    incrementPg(){
        var fp_len=this.img1.getAttribute("src").length;
        var fp=this.img1.getAttribute("src").slice(0,fp_len-this.pdf_filter.length);
        var f_type=fp.slice(-4,fp_len);
        var base_fp=fp.slice(0,-4);
        var new_fp1=this.pdf_bp;
        var new_fp2=this.pdf_bp;

        var curren_pg=parseInt(this.img1.getAttribute("src").slice(base_fp.length-this.pg_num_slice,base_fp.length));
        var second_pg=0;

        if((curren_pg+1)<this.max_pg){
            curren_pg++;
            if(curren_pg>2){
                curren_pg++;
                second_pg=curren_pg+1;
                this.pg2.style.display = "";
                this.guidecontainer.setAttribute("class","guide_container double");
            }else{
                second_pg=curren_pg+1;
                this.pg2.style.display = "";
                this.guidecontainer.setAttribute("class","guide_container double");
            }

            curren_pg=curren_pg.toString();
            second_pg=second_pg.toString();
            
            new_fp1=(base_fp.slice(0,base_fp.length-this.pg_num_slice))+curren_pg+f_type+this.pdf_filter;
            new_fp2=(base_fp.slice(0,base_fp.length-this.pg_num_slice))+second_pg+f_type+this.pdf_filter;
        }else{
            this.pg2.style.display = "none";
            this.guidecontainer.setAttribute("class","guide_container single");
            curren_pg=1
        }

        if(curren_pg>9){
            this.pg_num_slice=2;
        }else{
            this.pg_num_slice=1;
        }

        this.img1.setAttribute("src",new_fp1);
        this.img2.setAttribute("src",new_fp2);
    }

    decrementPg(){
        var fp_len=this.img1.getAttribute("src").length;
        var fp=this.img1.getAttribute("src").slice(0,fp_len-this.pdf_filter.length);
        var f_type=fp.slice(-4,fp_len);
        var base_fp=fp.slice(0,-4);
        var new_fp1=this.pdf_bp;
        var new_fp2=this.pdf_bp;
        
        var curren_pg=parseInt(this.img1.getAttribute("src").slice(base_fp.length-this.pg_num_slice,base_fp.length));
        var second_pg=0;

        if(curren_pg>1){
            curren_pg--;

            if(curren_pg>2){
                curren_pg--;
                second_pg=curren_pg+1;
                this.guidecontainer.setAttribute("class","guide_container double");
                this.pg2.style.display = "";
            }else{
                this.guidecontainer.setAttribute("class","guide_container single");
                this.pg2.style.display = "none";
            }

            curren_pg=curren_pg.toString();
            second_pg=second_pg.toString();

            new_fp1=(base_fp.slice(0,base_fp.length-this.pg_num_slice))+curren_pg+f_type+this.pdf_filter;
            new_fp2=(base_fp.slice(0,base_fp.length-this.pg_num_slice))+second_pg+f_type+this.pdf_filter;
        }else{
            new_fp1=(base_fp.slice(0,base_fp.length-this.pg_num_slice))+(this.max_pg-1).toString()+f_type+this.pdf_filter;
            new_fp2=(base_fp.slice(0,base_fp.length-this.pg_num_slice))+this.max_pg.toString()+f_type+this.pdf_filter;
            this.guidecontainer.setAttribute("class","guide_container double");
            curren_pg=this.max_pg-1;
            this.pg2.style.display = "";
        }

        if(curren_pg>9){
            this.pg_num_slice=2;
        }else{
            this.pg_num_slice=1;
        }

        this.img1.setAttribute("src",new_fp1);
        this.img2.setAttribute("src",new_fp2);
    }

}
    
customElements.define("flip-book", FlipBook);